import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'ticketing-product-list',
  name: '门票列表',
  icon: '票',
  group: '票务组件',
  description: '以商品列表样式展示当前店铺的在售门票。',
  defaultProps: {
    title: '推荐门票',
    columns: 3,
    limit: 12
}
}
